export const getAuthToken = () => {
  return localStorage.getItem("offSetAuth") || null;
};

export const setAuthToken = (token) => {
  localStorage.setItem("offSetAuth", token);
};

export const removeAuthToken = () => {
  localStorage.removeItem("offSetAuth");
};
